import { VALUES } from "../../data";
import { Reveal, MaskLineInView } from "./Reveal";
import { Lightbulb, ShieldCheck, HeartHandshake } from "lucide-react";

const ICONS = [Lightbulb, ShieldCheck, HeartHandshake];

export const Values = () => (
  <section data-testid="values-section" className="bg-[var(--surface)] py-16 md:py-36">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="max-w-2xl">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--brand)]">
            Core Values
          </span>
        </Reveal>
        <h2 className="font-display font-semibold tracking-tighter leading-[0.98] mt-5 text-4xl md:text-6xl">
          <MaskLineInView>What we</MaskLineInView>
          <MaskLineInView delay={0.08}>optimize for.</MaskLineInView>
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
        {VALUES.map((v, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={v.t} delay={i * 0.1}>
              <div
                data-testid={`value-${i}`}
                className="group h-full rounded-3xl bg-white border border-slate-200 p-9 md:p-10 hover:bg-[var(--brand)] transition-colors duration-400"
              >
                <div className="w-12 h-12 rounded-2xl bg-[var(--brand)]/10 group-hover:bg-white/20 flex items-center justify-center text-[var(--brand)] group-hover:text-white transition-colors duration-400">
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-2xl font-medium mt-8 tracking-tight text-[var(--ink)] group-hover:text-white transition-colors duration-400">
                  {v.t}
                </h3>
                <p className="mt-4 leading-relaxed text-[var(--muted)] group-hover:text-white/85 transition-colors duration-400">
                  {v.d}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
